/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
}

/**
 * 获取localStorage
 */
export const getStore = name => {
  if (!name) return
  return window.localStorage.getItem(name)
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
  if (!name) return
  window.localStorage.removeItem(name)
}

/**
 * 存储Cookie
 */
export const setCookie = (name, value, exdays) => {
  const d = new Date()
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
  const expires = 'expires=' + d.toGMTString()
  document.cookie = name + '=' + value + '; ' + expires
}

/**
 * 获取Cookie
 */
export const getCookie = name => {
  name = name + '='
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    const c = ca[i].trim()
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

/**
 * 删除Cookie
 */
export const delCookie = name => {
  const exp = new Date()
  exp.setTime(exp.getTime() - 1)
  const cval = getCookie(name)
  if (cval != null)
    document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
}

/**
 * 获取系统信息
 */
export const getSystem = {
  isAndroid: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1,
  isIOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
}

/**
 * 获取url参数
 * @param {string} name 参数名称
 */
export const getQueryStr = name => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  const result = window.location.search.substr(1).match(reg)
  if (result != null) {
    return unescape(result[2])
  }
  return null
}

/**
 * 生成guid
 */
export const getGuid = () => {
  const tS4 = () => Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1)

  return tS4() + tS4() + '-' + tS4() + '-' + tS4() + '-' +
    tS4() + '-' + tS4() + tS4() + tS4()
}

/**
 * 时间戳转换
 * @param {string|number} date 时间戳
 * @param {string} fmt 返回日期时间格式
 */
export const formatDate = (date, fmt = 'yyyy-MM-dd hh:mm:ss') => {
  date = typeof date === 'number' ? new Date(date) : date
  const time = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'S': date.getMilliseconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (let k in time) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (time[k]) : (('00' + time[k]).substr(('' + time[k]).length)))
    }
  }
  return fmt
}

/**
 * 返回顶部
 * @param {number} y 距离顶部距离
 * @param {duration} y 返回动画时间
 */
export const toScroll = (y, duration) => {
  const initialY =
    document.documentElement.scrollTop || document.body.scrollTop
  const baseY = (initialY + y) * 0.5
  const difference = initialY - baseY
  const startTime = performance.now()

  const step = () => {
    let normalizedTime = (performance.now() - startTime) / duration
    if (normalizedTime > 1) normalizedTime = 1

    window.scrollTo(
      0,
      baseY + difference * Math.cos(normalizedTime * Math.PI)
    )
    if (normalizedTime < 1) window.requestAnimationFrame(step)
  }
  window.requestAnimationFrame(step)
}

/**
 * 判断时间是否在指定时间段内
 * @param {String} startDateStr 开始时间字符串
 * @param {String} endDateStr 结束时间字符串
 * @param {String} curDateStr 需检查时间字符串
 */
export const isDuringDate = (startDateStr, endDateStr, curDateStr) => {
  if (getSystem.isIOS) {
    startDateStr = startDateStr.replace(/\-/g, '/')
    endDateStr = endDateStr.replace(/\-/g, '/')
    if (curDateStr) curDateStr = curDateStr.replace(/\-/g, '/')
  }
  const curDate = curDateStr ? new Date(curDateStr) : new Date(),
    startDate = new Date(startDateStr),
    endDate = new Date(endDateStr)

  return curDate >= startDate && curDate <= endDate
}

/**
 * 复制文字
 * @param {String} text
 */
export const copyContent = text => {
  const input = document.createElement("input")
  input.value = text
  document.body.appendChild(input)
  input.select()
  document.execCommand("Copy")
  document.body.removeChild(input)
}

/**
 * 对象obj转url参数
 */
export const objToUrlParams = obj => {
  let path = ''
  for (const key in obj) {
    const str = path === '' ? '?' : '&'
    path += `${str + key}=${obj[key]}`
  }
  return path
}

/**
 * 表情图片列表
 */
export const faces = (function () {
  const alt = ["[微笑]", "[嘻嘻]", "[哈哈]", "[可爱]", "[可怜]", "[挖鼻]", "[吃惊]", "[害羞]", "[挤眼]", "[闭嘴]", "[鄙视]", "[爱你]", "[泪]", "[偷笑]", "[亲亲]", "[生病]", "[太开心]", "[白眼]", "[右哼哼]", "[左哼哼]", "[嘘]", "[衰]", "[委屈]", "[吐]", "[哈欠]", "[抱抱]", "[怒]", "[疑问]", "[馋嘴]", "[拜拜]", "[思考]", "[汗]", "[困]", "[睡]", "[钱]", "[失望]", "[酷]", "[色]", "[哼]", "[鼓掌]", "[晕]", "[悲伤]", "[抓狂]", "[黑线]", "[阴险]", "[怒骂]", "[互粉]", "[心]", "[伤心]", "[猪头]", "[熊猫]", "[兔子]", "[ok]", "[耶]", "[good]", "[NO]", "[赞]", "[来]", "[弱]", "[草泥马]", "[神马]", "[囧]", "[浮云]", "[给力]", "[围观]", "[威武]", "[奥特曼]", "[礼物]", "[钟]", "[话筒]", "[蜡烛]", "[蛋糕]"],
    arr = {}
  for (let i = 0; i < alt.length; i++) {
    arr[alt[i]] = require(`@/assets/image/face/${i}.gif`)
  }
  return arr
})()

/**
 * 检查信息类型
 * @param {String} rule 对比的type
 * @param {String} type 需校验的type
 */
export const checkType = (rule, type) => {
  let types = type.replace(/\s*/g, '').split(','),
    isAnd = rule.search('&') > -1,
    count = 0
  for (let i = 0; i < types.length; i++) {
    if (rule.search(types[i]) > -1) count++
  }
  if (isAnd) {
    const rulses = rule.replace(/\s*/g, '').split('&')
    return count >= rulses.length
  } else {
    return count > 0
  }
}

/**
 * 函数防抖
 * @param {function} fn 回调函数
 * @param {number} delay 间隔时间
 */
export const debounce = (fn, delay = 1000) => {
  let timer = null
  return function() {
    let args = arguments
    if (timer) {
      clearTimeout(timer)
      timer = null
    }
    timer = setTimeout(() => {
      fn.apply(this, args) // this 指向vue
    }, delay)
  }
}

/**
 * 函数节流
 * @param {function} fn 回调函数
 * @param {number} delay 间隔时间
 */
export const thorttle = (fn, delay = 1000) => {
  let lastTime = ''
  let timer = ''
  let interval = delay
  return function () {
    let args = arguments
    let nowTime = Date.now()
    if (lastTime && nowTime - lastTime < interval) {
      clearTimeout(timer)
      timer = setTimeout(() => {
        lastTime = nowTime
        fn.apply(this, args)
      }, interval)
    } else {
      lastTime = nowTime
      fn.apply(this, args)
    }
  }
}

/**
 * 解析反馈消息内容
 * @param {String} content 消息内容
 * @returns {Object} 解析后的反馈数据
 */
export function parseFeedbackMessage(content) {
  const data = {
    description: '',
    name: '',
    phone: '',
    province: '',
    city: '',
    district: '',
    address: '',
    fullAddress: '',
    status: 0
  }

  // 移除HTML标签
  const plainContent = content.replace(/<[^>]*>/g, '')

  // 解析反馈问题
  const descMatch = plainContent.match(/反馈问题[:：]\s*(.+?)(?=\n|$)/i)
  if (descMatch) data.description = descMatch[1].trim()

  // 解析姓名（支持多种格式：姓名:、姓名：、姓名，）
  const nameMatch = plainContent.match(/姓名[:：,，]\s*(.+?)(?=联系|区县|区域|\n|$)/i)
  if (nameMatch) data.name = nameMatch[1].trim()

  // 解析联系电话（支持多种格式：联系电话:、联系电活:、联系电话）
  const phoneMatch = plainContent.match(/联系电[话活][:：]?\s*(\d+)(?=\s|联系|区县|区域|\n|$)/i)
  if (phoneMatch) data.phone = phoneMatch[1].trim()

  // 解析联系地址
  const addressMatch = plainContent.match(/联系地址[:：]\s*(.+?)(?=\n|$)/i)
  if (addressMatch) {
    const fullAddr = addressMatch[1].trim()
    data.address = fullAddr

    // 尝试从地址中提取省市区
    const provinceMatch = fullAddr.match(/(.+?省)/)
    const cityMatch = fullAddr.match(/(.+?市)/)

    if (provinceMatch) data.province = provinceMatch[1]
    if (cityMatch) data.city = cityMatch[1]
  }

  // 解析区县（支持"区县:"和"区域:"两种格式）
  const districtMatch = plainContent.match(/(?:区县|区域)[:：]\s*(.+?)(?=请|$)/i)
  if (districtMatch) data.district = districtMatch[1].trim()

  // 构建完整地址
  data.fullAddress = `${data.province}${data.city}${data.district}${data.address}`.trim()

  return data
}


// WEBPACK FOOTER //
// ./src/assets/script/utils.js